import { type ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

interface ProtectedRouteProps {
  children: ReactNode;
  tableName?: string;
  operation?: 'Select' | 'Insert' | 'Update' | 'Delete';
}

function ProtectedRoute({ children, tableName, operation }: ProtectedRouteProps) {
  const { session, isLoading, hasPermission } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <div style={{textAlign: 'center', padding: '4rem'}}>Verificando sessão...</div>;
  }

  if (!session) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }
  
  if (tableName && operation && !hasPermission(tableName, operation)) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
}

export default ProtectedRoute;